<template>
  <div>
    <div class="fixed-top">
      <header>
        <div style="
            display: flex;
            justify-content: space-between;
            background: #f8f9fa;
            align-items: center;
            padding: 0px 15px 0px 15px;
          ">
          <div style="display: flex; align-items: center; gap: 10px">
            <div class="mobile-navbar-toggle d-block d-lg-none">
              <b-navbar-toggle target="nav-collapse" class="mx-auto my-1 custom-toggle">
                <svg fill="#004c40" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <g id="SVGRepo_bgCarrier" stroke-width="0" />
                  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
                  <g id="SVGRepo_iconCarrier">
                    <title>bars</title>
                    <path
                      d="M2 8.749h28c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0h-28c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0zM30 15.25h-28c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0h28c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0zM30 23.25h-28c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0h28c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0z" />
                  </g>
                </svg>
              </b-navbar-toggle>
            </div>
            <div>
              <router-link to="/">
                <img class="img-logo" src="../assets/app/logo-version-allongee-baseline-couleur.png" fluid />
              </router-link>
            </div>
          </div>

          <div style="display: flex; gap: 10px; flex-wrap: wrap">
            <PersonalSpace />

            <!-- ✅ On se base sur un état réactif, pas sur userState.isLoggedIn() directement -->
            <button v-if="!isLoggedIn" @click="handleClickOnSubscribeButton" class="btn btn-order">
              <span class="hide-in-small-devices">Je m'inscris gratuitement</span>
              <font-awesome-icon icon="fa-solid fa-right-to-bracket" />
            </button>

            <a
              href="https://www.helloasso.com/associations/association-des-meilleurs-mangeurs/collectes/financement-participatif-de-mes-meilleurs-menus"
              class="btn-don d-none d-md-block"
              target="_blank"
            >
              <button class="btn btn-order">
                Je fais un don
                <font-awesome-icon :icon="['fas', 'hand-holding-heart']" />
              </button>
            </a>
          </div>
        </div>
      </header>

      <b-navbar toggleable="lg" variant="faded" class="nav-background-color">
        <b-container fluid class="d-flex justify-content-center align-items-center">
          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="">
              <b-nav-item :to="{ name: 'accueil' }" exact>Mes Meilleurs Menus</b-nav-item>
              <b-nav-item :to="{ name: 'recipes' }" active-class="router-link-active"><span style="text-transform: none;">Recettes</span></b-nav-item>
              <b-nav-item :to="{ name: 'mealim-recipe' }" exact><span style="text-transform: none;">Analyser mon repas</span></b-nav-item>
              <b-nav-item :to="{ name: 'mealim-workshop' }" exact><span style="text-transform: none;">Ateliers</span></b-nav-item>
              <b-nav-item :to="{ name: 'meilleurs-mangeurs' }">Meilleurs Mangeurs</b-nav-item>
              <b-nav-item :to="{ name: 'notre-demarche' }">Notre démarche</b-nav-item>
              <b-nav-item :to="{ name: 'conseils-scientifique' }">Conseil Scientifique</b-nav-item>
              <b-nav-item :to="{ name: 'blog-list' }">Actualités</b-nav-item>
            </b-navbar-nav>
          </b-collapse>
        </b-container>
      </b-navbar>
    </div>

    <router-view />
  </div>
</template>

<script>
import PersonalSpace from "./PersonalSpace.vue";
import { userState } from "@/utils/store";
import { useRouter } from "vue-router/composables";
import { ref, onMounted, onBeforeUnmount } from "vue";

export default {
  name: "NavbarLayout",
  components: { PersonalSpace },
  setup() {
    const router = useRouter();
    const isLoggedIn = ref(false);

    const refreshAuthState = () => {
      // 1) via store (si dispo)
      let storeLogged = false;
      try {
        if (userState && typeof userState.isLoggedIn === "function") {
          storeLogged = !!userState.isLoggedIn();
        }
      } catch (e) {
        storeLogged = false;
      }

      // 2) fallback via tokens
      const access = localStorage.getItem("accessToken");
      const refresh = localStorage.getItem("refreshToken");
      const tokenLogged = !!(access || refresh);

      // ✅ connecté si l’un des deux est vrai
      isLoggedIn.value = storeLogged || tokenLogged;
    };

    const handleClickOnSubscribeButton = () => {
      // Ce bouton n’existe que si !isLoggedIn, donc inscription directe
      router.push({ name: "inscription" });
    };

    const onFocus = () => refreshAuthState();
    const onVisibilityChange = () => {
      if (!document.hidden) refreshAuthState();
    };

    onMounted(() => {
      refreshAuthState();
      window.addEventListener("storage", refreshAuthState);
      window.addEventListener("focus", onFocus);
      document.addEventListener("visibilitychange", onVisibilityChange);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("storage", refreshAuthState);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    });

    return {
      userState,
      isLoggedIn,
      handleClickOnSubscribeButton,
    };
  },
};
</script>

<style scoped>
.custom-toggle {
  background-color: rgba(255, 255, 255, 1);
  border: none;
}

a button span {
  color: white;
  text-decoration: none;
  list-style: none;
}

.b-collapse {
  display: flex;
  justify-content: center;
}

.navbar-nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

@media (min-width: 992px) {
  .navbar-nav { flex-wrap: nowrap; }
  .navbar-nav > li { flex: 0 0 auto; }
  .navbar-nav .nav-link {
    white-space: nowrap;
    padding-left: .42rem !important;
    padding-right: .42rem !important;
    font-size: 12px;
  }
}

@media (min-width: 1200px) {
  .navbar-nav .nav-link { font-size: 13px; }
}

.navbar {
  padding: 0;
  font-family: "TangoSans";
}

.nav-link {
  white-space: nowrap;
  color: white;
  transition: 0.3s;
  padding: 13px;
  font-size: 14px;
}

.nav-link:hover {
  color: #ffffff;
  background-color: rgb(133, 187, 47);
}

a.nav-link.router-link-active,
a.nav-link.router-link-exact-active,
.nav-link.active {
  color: #ffffff;
  background-color: rgb(133, 187, 47);
}

.nav-background-color {
  background-color: #004c40;
  font-size: 18px;
  font-weight: 300;
  text-transform: capitalize;
  letter-spacing: 0.4px;
}

.btn-order {
  color: white;
  background-color: #004c40;
  transition: 0.3s;
  font-family: "TangoSans";
}

.btn-order:hover,
.btn-order:active {
  color: #004c40;
  background-color: white;
  border-color: #004c40;
}

.img-logo {
  height: 100px;
}

.mobile-navbar-toggle svg {
  width: 30px;
}

@media (max-width: 992px) {
  .btn-don,
  .btn-order {
    font-size: 12px;
  }
}

@media (max-width: 1233px) {
  .nav-link {
    font-size: 12px;
  }
}

@media (max-width: 1087px) {
  .nav-link {
    font-size: 10px;
  }
}

@media (max-width: 510px) {
  .img-logo[data-v-7e3a0e8a] {
    width: 150px;
    height: auto;
  }
}

@media (max-width: 400px) {
  .hide-in-small-devices {
    display: none;
  }
}
</style>
